import './register_common_react';
import { reactOnCms } from 'common/js/react_on_cms';
import ExpiryBookingCheck from 'components/expiry_booking_check';
import MetaFlow from 'tenants/sealink/meta_flow';
import SubNavigationBar from 'tenants/sealink/meta_flow/sub_navigation_bar';

reactOnCms.register({
  ExpiryBookingCheck,
  SubNavigationBar,
  MetaFlow,
});
